import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryToolsIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-tools"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M19.1839 20.4722C19.2911 20.7428 19.1534 21.0483 18.8797 21.1473L16.6445 21.9559C16.3745 22.0536 16.0711 21.9136 15.9703 21.6446L11.3669 8.64321C11.2768 8.38869 11.409 8.10909 11.6628 8.01732L13.4817 7.35925C13.7316 7.26889 14.0079 7.39346 14.1057 7.64047L19.1839 20.4722Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M13.2701 5.10567L13.6262 6.05856C13.7121 6.28841 13.6121 6.53643 13.4042 6.65054C13.405 6.65226 13.4066 6.65744 13.4074 6.65917L13.3373 6.68465L11.7929 7.24485L11.0734 7.50577C10.7051 7.63937 10.3282 7.53836 10.2333 7.28435L9.9523 6.53237C9.86072 6.54963 9.7728 6.57765 9.68255 6.61044C9.2325 6.77358 8.89209 7.10475 8.70671 7.50536C8.69453 7.55237 8.67402 7.59602 8.65219 7.63937C8.62103 7.80079 8.50621 7.94049 8.339 8.0011L6.80082 8.56404C6.5458 8.65643 6.26357 8.52617 6.16864 8.27206L5.03118 5.22952C4.93626 4.97562 5.06529 4.69602 5.32022 4.60343L6.86458 4.04343C7.03169 3.98272 7.20844 4.02181 7.33839 4.12475C7.38326 4.14353 7.42793 4.16394 7.46803 4.19186C7.87301 4.37866 8.34986 4.41308 8.80001 4.24983C8.89128 4.21673 8.97179 4.17399 9.05341 4.1281L8.91301 3.75216C8.82996 3.53023 8.98895 3.26221 9.27544 3.10942C9.45047 3.03886 9.62326 2.96221 9.80742 2.90648C13.7826 1.70221 16.2902 2.04516 16.2902 2.04516C16.2902 2.04516 17.6535 2.07247 18.2428 2.9811C16.4512 2.93998 12.8964 4.19551 13.2701 5.10567Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryToolsIcon.displayName = 'CategoryToolsIcon';
